import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { ContentItemPlusCft } from "scmp-app/components/content/content-item-render/variants/plus-cft";

export const StyledContentItemPlusCft = styled(ContentItemPlusCft)`
  inline-size: 100%;

  img {
    inline-size: 100%;
  }
`;

export const ContentItemContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 225px));
  gap: 32px 24px;

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns: repeat(3, minmax(210px, 280px));
    gap: 32px 24px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div``;

export const LoadMoreButton = styled.button`
  display: block;

  inline-size: 100%;
  margin-block-start: 32px;
  margin-inline: auto;

  color: #4585ff;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 200%;

  border: 1px solid #4585ff;
  border-radius: 4px;

  background-color: transparent;

  cursor: pointer;
`;
